import script from "./filter-checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./filter-checkbox.vue?vue&type=script&setup=true&lang=js"

import "./filter-checkbox.vue?vue&type=style&index=0&id=2ffb030e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffb030e"]])

export default __exports__